module.exports = __webpack_public_path__ + "vue/img/report_class.b157d658.jpg";